import { useFormContext } from "react-hook-form";

import classNames from "classnames";
import check from "./images/check.svg";
import Icon from "./Icon";

const IconElement = ({ eventHandler, name, id, league, sport, icon, size }) => {
  const { register } = useFormContext();

  const isLarge = size === "lg" ? true : false;
  const isMedium = size === "md" ? true : false;
  const isSmall = size === "sm" ? true : false;

  return (
    <div className="flex flex-col justify-center items-center">
      <input
        type="checkbox"
        {...register(id)}
        id={id}
        className="hidden appearance-none input-checkbox"
        onClick={(event) => eventHandler(id, league, sport, event)}
      />
      <label
        htmlFor={id}
        className={classNames(
          "block overflow-hidden relative rounded-xl border cursor-pointer bg-zinc-900",
          {
            "w-20 h-20 md:w-24 md:h-24 border-zinc-600": isSmall,
            "w-36 h-36 border-zinc-900": isMedium,
            "w-44 h-44 border-zinc-900": isLarge,
          }
        )}
      >
        <div className="flex absolute top-1 right-1 invisible justify-center items-center w-4 h-4 text-black bg-yellow-400 rounded-full checkbox-check">
          <img src={check} alt="✔" className="w-3 h-3" loading="lazy" />
        </div>

        <div
          className={classNames("absolute", {
            "top-3 left-3 w-14 h-14 md:left-5 md:top-5": isSmall,
            "top-6 left-8 w-[5rem] h-[4rem]": isMedium,
            "top-8 left-12 w-20 h-20": isLarge,
          })}
        >
          <Icon
            icon={icon}
            className={classNames("absolute", {
              "w-10 h-10": isSmall,
              "w-12 h-12": isMedium,
              "w-16 h-16": isLarge,
            })}
          />
        </div>

        {!isSmall && (
          <p
            className={classNames(
              "absolute px-2 w-full text-center text-white",
              {
                "bottom-1 text-xs": isSmall,
                "bottom-4 text-sm": isMedium,
                "bottom-4 text-md": isLarge,
              }
            )}
          >
            {name}
          </p>
        )}
      </label>
    </div>
  );
};

export default IconElement;
